import React, {createContext, useContext, useEffect, useState} from 'react';
import {useColorScheme} from 'react-native';
import Cookies from 'universal-cookie';
import {lightColors, darkColors} from './AppColor';

const cookies = new Cookies();
const THEME_COOKIE_KEY = 'appTheme';

const ThemeContext = createContext({
  isDark: false,
  colors: lightColors,
  toggleTheme: () => {},
});

export const ThemeProvider = ({children}) => {
  const systemScheme = useColorScheme();

  const [isDark, setIsDark] = useState(() => {
    const saved = cookies.get(THEME_COOKIE_KEY);
    if (saved === 'dark') return true;
    if (saved === 'light') return false;
    return systemScheme === 'dark';
  });

  // Sync <html> class for Tailwind dark: variants
  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(prev => {
      const next = !prev;
      cookies.set(THEME_COOKIE_KEY, next ? 'dark' : 'light', {path: '/'});
      return next;
    });
  };

  return (
    <ThemeContext.Provider
      value={{isDark, colors: isDark ? darkColors : lightColors, toggleTheme}}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

// Convenience hook — returns the active color palette
export const useThemeColors = () => useContext(ThemeContext).colors;

// Export context object for class components using static contextType
export {ThemeContext};
